import { useAtomValue } from "jotai";
import type { JSX } from "react";

import {
  Field,
  FieldContent,
  FieldLabel,
} from "@frontend/components/atoms/Field";
import { Input } from "@frontend/components/atoms/Input";
import { useField } from "@frontend/hooks/form";
import { ReferenceField } from "@frontend/shared/reference-field";
import { useLingui } from "@lingui/react/macro";

import { optionsAtom, projectForm } from "../stores/editor";
import { Section } from "./Section";

const fields = projectForm.fields;

/** Where the subscription comes from. */
export function ProvenanceSection(): JSX.Element {
  const { t } = useLingui();

  const options = useAtomValue(optionsAtom);

  const quotationNumber = useField(fields.quotationNumber);

  return (
    <Section
      icon="FileSignature"
      legend={t`Quotation and provenance`}
      gutter={false}
    >
      <Field>
        <FieldLabel>{t`Quotation number`}</FieldLabel>

        <FieldContent>
          <Input
            value={quotationNumber.value ?? ""}
            onChange={(event) => quotationNumber.setValue(event.target.value)}
          />
        </FieldContent>
      </Field>

      <ReferenceField
        label={t`Originating affiliate`}
        placeholder={t`Please choose an option`}
        items={options.affiliates}
        field={fields.subscription.fields.initialAffiliateId}
      />
    </Section>
  );
}
